import * as yup from 'yup'

import constants from 'constants/index'

export const schema = (editionMode) =>
  yup.object().shape({
    name: yup.string().required().max(100),
    responsible: yup.string().when('documentKind', {
      is: (value) => value === 'cnpj',
      then: yup.string().required(),
    }),
    dpo: yup.string().when('kind', {
      is: (value) => value === constants.organizations.DPO_KIND,
      then: yup.string().required(),
    }),
    substitute: yup.string().when('kind', {
      is: (value) => value === constants.organizations.DPO_KIND,
      then: yup.string().required(),
    }),
    ...(!editionMode && {
      kind: yup.string().required(),
      documentKind: yup.string().when('kind', {
        is: (value) => value === constants.organizations.DPO_KIND,
        then: yup.string().required(),
      }),
      cpf: yup.string().when('documentKind', {
        is: (value) => value === 'cpf',
        then: yup.string().required().cpf(),
      }),
      cnpj: yup.string().when('documentKind', {
        is: (value) => value === 'cnpj',
        then: yup.string().required().cnpj(),
      }),
      responsibleName: yup.string().when('selectExistentResponsible', {
        is: (value) => !value,
        then: yup.string().required(),
      }),
      responsibleEmail: yup.string().when('selectExistentResponsible', {
        is: (value) => !value,
        then: yup.string().email().required(),
      }),
      responsibleDpo: yup.object().when('selectExistentResponsible', {
        is: (value) => value,
        then: yup.object().required().typeError('Preencha esse campo'),
      }),
    }),
  })

export default schema
